import { render } from "./ExplanationPane.vue?vue&type=template&id=32e993af&scoped=true"
import script from "./ExplanationPane.vue?vue&type=script&lang=js"
export * from "./ExplanationPane.vue?vue&type=script&lang=js"

import "./ExplanationPane.vue?vue&type=style&index=0&id=32e993af&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32e993af"

export default script